export default {
  title: "管理后台",
  titleFr: "Admin livraison",
  footerWechatDev: "微信开发",
  footerWechatApp: "微信应用",
  footerMiniProgram: "小程序开发",
  footerPowered: "Powered by",
  footerW7: "微擎",
};
